import {
  Breakpoints,
  CTA,
  styled,
  Text,
  TextTag,
} from '@volkswagen-onehub/components-core';
import React, {useContext, useEffect, useState} from 'react';
import {URLSearchParamsInit} from 'react-router-dom';
import {Route} from '../utils/use-route';
import {getLang, getTranslations} from '../translations';
import {ResultsView, ResultsViewContext} from '../utils/results-view-context';
import { VehicleData } from '../types';
import { AppContext } from '../app-context';

interface SoldDescriptionInterface {
  vehicle: VehicleData;
}

const SoldDescriptionContainer = styled.div<{view?: ResultsView}>`
  grid-area: colours;
  margin-top: ${(props) => props.theme.size.static150};
  margin-bottom: ${(props) => props.theme.size.static150};
  padding: ${(props) => props.theme.size.dynamic0020} 0;
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.dynamic0020};

  @media screen and (min-width: ${Breakpoints.b960}px) {
    grid-area: ${(props) =>
      props.view == ResultsView.LIST ? 'description' : 'colours'};
    padding-left: ${(props) => (props.view == ResultsView.LIST ? '36px' : '0')};
  }
`;

const SoldDescription: React.FC<SoldDescriptionInterface> = ({vehicle}) => {
  const lang = getLang();
  const {labels} = getTranslations();
  const { pageBaseUrl } = useContext(AppContext);
  const view = useContext(ResultsViewContext).value;
  const [params, setParams] = useState<URLSearchParamsInit | undefined>(
    undefined,
  );

  useEffect(() => {
    if (!vehicle) return;

    let modelName = vehicle.model_name.replace(/[. ]/g, '').toLocaleLowerCase();

    setParams({
      model: modelName,
      year: vehicle.year + ':' + vehicle.year,
      trimline: vehicle.trimline,
    });
  }, [vehicle]);

  return (
    <SoldDescriptionContainer view={view}>
      <Text>{labels.newSearch.copy}</Text>
      <CTA
        ariaLabel={labels.newSearch.cta}
        tag="a"
        href={
          pageBaseUrl?.dispatcher[lang] +
          '/' +
          Route.RESULTS +
          '?' +
          new URLSearchParams(params as URLSearchParams).toString()
        }
        emphasis="tertiary"
      >
        <Text bold tag={TextTag.span}>
          {labels.newSearch.cta}
        </Text>
      </CTA>
    </SoldDescriptionContainer>
  );
};

export default SoldDescription;
